<template>
  <button :disabled="form.processing" :class="{ 'opacity-25': form.processing }" class="flex items-center">
    <div v-if="form.processing" class="fa fa-circle-notch fa-spin mr-2" />
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    form: Object,
  },
}
</script>
